import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import ArcFault from '../../../../assets/safety/2.1-arc-fault.jpg';
import { FaHome } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import HomeNav from '../../../../components/HomeNav';

import 'bootstrap/dist/css/bootstrap.min.css';

const SIElectricalSafety = () => {
	const [activeKey, setActiveKey] = useState('Electrical Safety');
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Safety</Breadcrumb.Item>
							<Breadcrumb.Item active>Control Safety</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs activeKey={activeKey} onSelect={setActiveKey} className="mb-3 safety-element">
								<Tab eventKey="Electrical Safety" title="Electrical Safety">
									<h2>ELECTRICAL SAFETY</h2>
									<p>The outline below provides Electrical safety precautions:</p>
									<ul>
										<li>Only qualified technicians familiar with the system, using an up-to-date set of system schematics, should perform electrical/electronic system troubleshooting or maintenance.</li>
										<li>Avoid wearing glasses that have a metal frame.</li>
										<li>Avoid wearing necklaces, watches, bracelets, earrings, rings, or chains that are made of a metallic substance.</li>
										<li>
											It must be always assumed that power is <b>"ON"</b> so all conditions must be treated as live. This practice develops a caution that may prevent an accident.
										</li>
										<li>Ground connections cause fault currents to flow directly into the ground instead of flowing through the body into the ground. All electrical apparatus must be properly grounded.</li>
										<li>Always use electrically insulated tools and utilize shock avoidance techniques.</li>
										<li>
											Remove Load from circuit or equipment. Before performing maintenance or service on any part of the Electrical System, perform all applicable <b>LOTO</b> procedures.
										</li>
										<li>Before performing any work on the system, verify that power is removed from all circuits.</li>
										<li>Electrical panels must not be opened if the ground light is on by anyone other than a qualified, authorized electrician for any reason.</li>
										<li>Capacitors must be given time to discharge, otherwise it should be done manually with care.</li>
										<li>Before any repair work is conducted on electrical circuitry, a voltage check using the proper test equipment must be made to ensure that dangerous voltages do not remain in the circuitry.</li>
										<div class="note">
											<p>Test equipment must be checked at regular intervals.</p>
										</div>
										<li>USE CAUTION when connecting test equipment probes to test points. Shock hazards could exist at the test points or in the test point area and/or transients induced by the probes could cause a machine action.</li>
									</ul>
									<p>If it is necessary to perform troubleshooting with the power on, know where power is present and proceed with extreme caution. Whenever possible, use electrically insulated tools. When troubleshooting "LIVE" equipment, take the following precautions:</p>
									<ul>
										<li>Make certain your tools and body are clear of potential grounds.</li>
										<li>Use extra precaution in damp areas.</li>
										<li>Be alert and work without any outside distraction.</li>
										<li>
											When servicing electrical enclosures, follow all <b>PPE</b> (personal protective equipment) requirements per posted arc flash warnings in accordance with plant safety specifications.
										</li>
										<li>Orange wire (or wires tagged with orange ends) identifies circuits that receive power from an external source, for example, an electrical enclosure lighting circuit. These circuits may still have power when the main disconnect switch or circuit breaker associated with the Electrical System is OPEN. Use extreme caution when working where this type of circuit is present.</li>
										<li>When conductors are replaced, they must conform to the manufacturer's specifications, including proper color-coding.</li>
										<li>Always use an appropriate fuse puller. Only regulation fuses, with their physical and electrical characteristics clearly specified, are to be used as replacements. Never attempt to replace a specified fuse with a higher-rated fuse (such as replacing a 5-amp fuse with a 10-amp fuse).</li>
										<li>Before applying power to any equipment, establish, without any doubt, that all persons are clear.</li>
										<li>The control panel doors shall be open only when it is necessary to check out the electrical equipment or wiring. After closing the door, make certain that the disconnecting means is operating properly with the disconnect handle mechanism.</li>
										<li>All covers on junction boxes must be closed before leaving any job.</li>
										<li>
											Before restarting equipment, read and understand all warnings, markings, and notices.
											<ul>
												<li>Read all markings such as nameplates and identification plates.</li>
												<li>Do not alter circuits unless authorized to do so by the manufacturer.</li>
												<li>Do not alter or bypass protective interlocks.</li>
												<li>Do not place jumper wires across fuses or trip switches.</li>
												<li>Do not alter over-current protective devices.</li>
											</ul>
										</li>
										<li>
											Refer to the Motor <b>LOTO</b> Procedures for the proper procedure of verifying the complete lockout of power sources.
										</li>
									</ul>

									<h2>ARCING FAULT HAZARDS</h2>

									<div class="warning">
										<p>Arcing fault hazards exist at all live electrical panels and precautions must be taken when opening any one of them.</p>
									</div>
									<p>
										An <b>Arcing Fault</b> is the flow of current through the air between phase conductors or between phase conductors and a neutral or ground, and can be caused by any number of things, ranging from faulty panel wiring to simply dropping a screwdriver or other tool inside a live panel. They can even occur when any conductive object gets too close to a high-amp current source or by simple equipment failure (i.e., opening or closing disconnects). The hazards of arcing faults come in multiple forms.
									</p>

									<p>
										An <b>Arc Flash</b> is exposure to the tremendous thermal energy released by an arcing fault. Arc Flash can occur if a conductive object gets too close to a high-amp current source or by equipment failure (for instance, opening or closing disconnects). The arc can heat the air to temperatures as high as 35,000° F, so hot that even metal inside the panel can be vaporized. The heat of an arc flash can cause incurable third degree burns and can even ignite clothing from up to ten feet away.
									</p>

									<p>
										An <b>Arc Blast</b> is exposure to the pressure blast released by an arcing fault. When conductive metals are vaporized by the immense heat of an arcing fault, they expand to 67,000 times their volume instantaneously. This rapid expansion results in an explosion of concussive forces that can propel molten metals and shrapnel away from the arc center.
									</p>

									<p>Electrical maintenance personnel should be fully trained in arc flash safety and protection procedures before attempting any maintenance on electrical equipment.</p>

									<figure style={{ width: '50vw' }} id="arc-fault-fig">
										<img src={ArcFault} alt="Arc Fault" style={{ width: '100%' }} />
										<figcaption>Figure 1: Arc Flash Sequence</figcaption>
									</figure>

									<p>
										<b>Figure 1</b> above shows sequential photos of one of many staged tests that helped to understand and quantify the effects of arcing faults on workers. In this test, mannequins with temperature and pressure sensors were placed in the test cell. This was a 480 volt, three phase system with an available three phase short-circuit current of 22,600 symmetrical rms amperes. A noncurrent limiting over current protective device was the nearest upstream protective device. An arcing fault was initiated in a combination motor controller enclosure. The arcing fault quickly escalated into a three-phase arcing fault in the enclosure. The current flowed for 6 cycles (1/10 second). The temperature recorders (with maximum temperature limit of 475° F) on the neck and hand of the mannequin closest to arcing fault were pegged (beyond 457° F limit) (threshold for incurable burn is for skin to reach 205° F for 1/10 second).
									</p>

									<p>The pressure sensor on this mannequin’s chest pegged the recorder at over 2160 lbs/ft&#178; (the threshold for severe lung damage is 2160 lbs/ft&#178;).</p>

									<h2>ARC FLASH SAFE PRACTICES</h2>
									<ul>
										<li>Always observe the safe working depth and clearance for turning on the disconnect switch.</li>
										<li>Never face a disconnect when placing it into the open or closed position; stand off to the side of the panel and turn your body away from the disconnect.</li>
										<li>
											Always wear <b>PPE</b> (personnel protective equipment) appropriate to the hazard present as dictated by established flash protection boundaries (FPBs).
										</li>
										<li>Be aware of all warning labels and understand them fully before attempting to service.</li>
									</ul>

									<h2>NFPA 70 E</h2>
									<p>
										An electrical incident can claim lives and cause permanently disabling injuries. Hundreds of deaths and thousands of burn injuries occur each year due to shock, electrocution, arc flash, and arc blast -- and most could be prevented through compliance with NFPA 70E: Standard for Electrical Safety in the Workplace®. Originally developed at OSHA's request, NFPA 70E covers the latest information about the effects of arc flash, arc blast, and direct current (dc) hazards, as well as recent developments in electrical design and Personal Protective Equipment (<b>PPE</b>).
									</p>

									<p>110.16 FLASH PROTECTION. Switchboards, panelboards, industrial control panels, and motor control centers in other than dwelling occupancies that are likely to require examination, adjustment, servicing, or maintenance while energized, shall be field marked to warn qualified persons of potential electric arc flash hazards. The marking shall be located to be clearly visible to qualified persons before examination, adjustment, servicing, or maintenance of the equipment.</p>

									<p>FPN No. 1: NFPA 70E-2000, Electrical Safety Requirements for Employee Workplace, aids in determining severity of potential exposure, planning safe work practices, and selecting personal protective equipment.</p>

									<p>FPN No. 2: ANSI Z535.4-1998, Product Safety Signs and Labels, provides guidelines for the design of safety signs and labels for application to products.</p>
								</Tab>

								<Tab eventKey="Mechanical Safety" title="Mechanical Safety">
									<h2>MECHANICAL SAFETY</h2>
									<p>The outline below provides Mechanical safety precautions:</p>
									<ul>
										<li>Only qualified technicians familiar with the machine should perform mechanical maintenance, adjustments, or repairs.</li>
										<li>
											If mechanical service does not require machine power, perform the appropriate <b>LOTO</b> procedures to disconnect or dissipate energy sources.
										</li>
										<li>Keep all moving parts of machinery and surrounding areas free of rags, dirt, and excessive oil or metal debris.</li>
									</ul>
									<p>Extra caution must be exercised while working near an operating tool. Serious injury can result if personnel get in the way of moving parts while the machine is in any of its operating modes.</p>
									<p>A machine must not be restarted until the system has been double-checked, safety guards reinstalled, safety gates and doors locked, and all personnel have been informed of impending start-up.</p>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIElectricalSafety;
